import MuiToggleButton, {
  ToggleButtonProps as MuiToggleButtonProps,
} from '@mui/material/ToggleButton';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface ToggleButtonProps extends MuiToggleButtonProps {}

export const ToggleButton: React.FC<ToggleButtonProps> = ({ ...props }) => {
  return <MuiToggleButton {...props}></MuiToggleButton>;
};
